<div class="header-bg-home">
  <div class="content-body">
    <div class="textbox">
      <h1 [attr.data-text]="title">
        {{ title }}
      </h1>
    </div>
  </div>
</div>
